import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { OrgProvider } from './context/OrgContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppShell } from './components/AppShell';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { AdminUsers } from './pages/AdminUsers';
import { Assets } from './pages/Assets';
import { Fleet } from './pages/Fleet';
import { AssetDetail } from './pages/AssetDetail';
import { Uptime } from './pages/Uptime';
import { IncidentDetail } from './pages/IncidentDetail';
import { AdminIncidentCategories } from './pages/AdminIncidentCategories';
import { Alerts } from './pages/Alerts';
import { AdminAlertThresholds } from './pages/AdminAlertThresholds';
import { ComplianceDocuments } from './pages/ComplianceDocuments';
import { ComplianceChecklist } from './pages/ComplianceChecklist';
import { BabaPackets } from './pages/BabaPackets';
import { ComplianceDashboard } from './pages/ComplianceDashboard';
import { AdminPrograms } from './pages/AdminPrograms';
import { AdminFieldDefinitions } from './pages/AdminFieldDefinitions';
import { ReportingStudio } from './pages/ReportingStudio';
import { AdminTemplates } from './pages/AdminTemplates';
import { ReportProfiles } from './pages/ReportProfiles';
import { DerivedFields } from './pages/DerivedFields';
import { ValidationConfig } from './pages/ValidationConfig';
import { ReportRunner } from './pages/ReportRunner';
import { UtilityReports } from './pages/UtilityReports';
import { UsageReporting } from './pages/UsageReporting';
import { GrantReports } from './pages/GrantReports';
import { CarbonReporting } from './pages/CarbonReporting';
import { DeliveryConfigs } from './pages/DeliveryConfigs';
import { ReportSchedules } from './pages/ReportSchedules';
import { ExportsModule } from './pages/ExportsModule';
import { WorkOrders } from './pages/WorkOrders';
import { WorkOrderDetail } from './pages/WorkOrderDetail';
import { Invoices } from './pages/Invoices';
import { EnergyHubStatus } from './pages/EnergyHubStatus';
import { EnergyHubMappings } from './pages/EnergyHubMappings';
import { EnergyHubEvents } from './pages/EnergyHubEvents';
import { UsersManagement } from './pages/UsersManagement';
import { PlanEntitlements } from './pages/PlanEntitlements';
import { AuditLog } from './pages/AuditLog';
import { ProgramPacks } from './pages/ProgramPacks';
import { MnPower } from './pages/MnPower';
import { Artifacts } from './pages/Artifacts';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <OrgProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Dashboard />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/assets"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Assets />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <AdminUsers />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/fleet"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Fleet />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/fleet/assets/:assetId"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <AssetDetail />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/uptime"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Uptime />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/uptime/incidents/:incidentId"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <IncidentDetail />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/config/incident-categories"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <AdminIncidentCategories />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/alerts"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Alerts />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/config/alert-thresholds"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <AdminAlertThresholds />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/documents"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <ComplianceDocuments />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/checklist"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <ComplianceChecklist />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/baba"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <BabaPackets />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <ComplianceDashboard />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/programs"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <AdminPrograms />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/programs/:programId/fields"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <AdminFieldDefinitions />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/reporting-studio"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <ReportingStudio />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/templates"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <AdminTemplates />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/report-profiles"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <ReportProfiles />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/report-profiles/:profileId/derived-fields"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <DerivedFields />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/report-profiles/:profileId/validation"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <ValidationConfig />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/reports/:profileId"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <ReportRunner />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/utility-reports"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <UtilityReports />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/usage"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <UsageReporting />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/grants"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <GrantReports />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/carbon"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <CarbonReporting />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/data/exports"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <DeliveryConfigs />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/report-schedules"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <ReportSchedules />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/data/exports-module"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <ExportsModule />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/service/work-orders"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <WorkOrders />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/service/work-orders/:workOrderId"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <WorkOrderDetail />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/service/finance"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Invoices />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/energyhub"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <EnergyHubStatus />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/energyhub/mappings"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <EnergyHubMappings />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/energyhub/events"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <EnergyHubEvents />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <UsersManagement />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/plan"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <PlanEntitlements />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/audit"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <AuditLog />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/program-packs"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <ProgramPacks />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/data/mn-power"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <MnPower />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/data/artifacts"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Artifacts />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </OrgProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
